export class PbaConstants {
  public static readonly TNMM = 'TNMM/CPM';
}
